import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import urlifyObject from "urlify";
import format from "date-fns/format";

import { AppContext } from "../../App";
import InformationsTimetable from "./InformationsTimetable";
import Loader from "../../components-utils/Loader";
import I18n from "../../components-utils/quill-i18n";
import { authenticated } from "../../services/auth";
import { withConfiguration } from "../../services/config";
import {
  getInformations,
  saveInformations,
  getMerchantCategories,
  uploadInformationsFile,
  deleteInformationsFile,
  geocoding,
  checkSlug,
  duplicateCatalog,
} from "../../services/api";

import {
  validateObject,
  mandatory,
  mandatoryRTE,
  numberMin,
} from "../../services/validator";
import { constructError } from "../../services/errors.js";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Tab from "@material-ui/core/Tab";
import DeleteIcon from "@material-ui/icons/Delete";
import AddAPhoto from "@material-ui/icons/AddAPhoto";
import Map from "pigeon-maps";
import Marker from "pigeon-marker";

import "./Informations.css";

const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

const networks = [
  "Indépendant",
  "Go Sport",
  "Intersport",
  "Skimium",
  "Ski Republic",
  "SkiSet",
  "Sport 2000",
];

class Informations extends Component {
  state = {
    lang: "fr",
    randomSuffix: Math.random(),
    urlify: urlifyObject.create({
      spaces: "-",
      nonPrintable: "-",
      trim: true,
      toLower: true,
    }),
    zoom: undefined,
    geocoding: "",
    sourceMerchant: "",
  };

  async componentDidMount() {
    const auth = authenticated();
    const informations = await getInformations(auth.currentMerchant.code);
    const merchantCategories = await getMerchantCategories(
      auth.currentMerchant.code,
      auth.currentMerchant.kind
    );

    if (informations !== undefined) {
      this.setState({
        informations:
          informations.id !== undefined
            ? informations.value !== undefined &&
              informations.value["j-"] === undefined
              ? { ...informations, value: { ...informations.value, "j-": "" } }
              : informations
            : {
                name: auth.currentMerchant.name,
                slug: this.state.urlify(auth.currentMerchant.name),
                merchantCategoryId:
                  auth.currentMerchant.kind === "STAND"
                    ? ""
                    : merchantCategories[0].id,
                value: {
                  i18n: this.props.langs.reduce(
                    (acc, lang) => ({
                      ...acc,
                      [lang.code]: {
                        description: "",
                      },
                    }),
                    {}
                  ),
                  network:
                    auth.currentMerchant.kind === "STAND" ? networks[0] : "",
                  "j-": 7,
                },
              },
        merchantCategories,
        merchantCode: auth.currentMerchant.code,
        merchantKind: auth.currentMerchant.kind,
        isAdmin: auth.roles.includes("ADMIN"),
        showDuplicate: false,
      });
    }
  }

  changeInfo = (name) => (e) => {
    const value = e.target.value;
    this.setState((state) => ({
      informations: {
        ...state.informations,
        [name]: value,
      },
    }));
  };

  changeJsonInfo = (name, type = "string") => (e) => {
    const value = e.target.value;
    const typedValue = type === "number" ? parseInt(value, 10) : value;
    this.setState((state) => ({
      informations: {
        ...state.informations,
        value: {
          ...state.informations.value,
          [name]: isNaN(typedValue) ? value : typedValue,
        },
      },
    }));
  };

  informationsValidators = {
    name: [mandatory],
    slug: [mandatory],
    merchantCategoryId: [mandatory],
    value: {
      i18n: this.props.langs.reduce(
        (acc, lang) => ({
          ...acc,
          [lang.code]: { description: [mandatoryRTE] },
        }),
        {}
      ),
      "j-": [mandatory, numberMin(1)],
      network: [mandatory],
    },
  };

  validateSlug = (merchantCode, slug) => {
    return checkSlug(merchantCode, slug).then(
      (result) => (result.error !== undefined ? result.error : undefined),
      (error) => error
    );
  };

  saveInformations = () => {
    const { informations, urlify } = this.state;

    const notNew = informations && informations.id !== undefined;
    const errors = validateObject(informations, this.informationsValidators);

    this.setState(
      (state) => ({
        errors,
        informations: {
          ...state.informations,
          slug: urlify(state.informations.slug),
        },
      }),
      () => {
        const { snackbar, setInit } = this.props;
        const { informations, merchantCode } = this.state;
        if (this.state.errors !== undefined) {
          snackbar("Veuillez remplir tous les champs obligatoires", "error");
        } else if (!notNew) {
          this.validateSlug(merchantCode, informations.slug).then((result) => {
            if (result !== undefined) {
              this.setState(
                (state) => ({
                  errors: {
                    slug: "duplicate",
                  },
                }),
                () => {
                  snackbar(
                    "Veuillez modifier le champ slug, ce code doit être unique pour chaque marchand",
                    "error"
                  );
                }
              );
            } else {
              saveInformations(merchantCode, informations)
                .then((informations) =>
                  this.setState({ informations }, () => {
                    setInit(false);
                    snackbar("Informations enregistrées");
                  })
                )
                .catch((e) => {
                  console.log(e);
                  snackbar(
                    "Erreur pendant l'initialisation. " + e.message,
                    "error"
                  );
                });
            }
          });
        } else {
          saveInformations(merchantCode, informations)
            .then((informations) =>
              this.setState({ informations }, () => {
                setInit(false);
                snackbar("Informations enregistrées");
              })
            )
            .catch((e) => {
              console.log(e);
              snackbar(
                "Erreur pendant l'initialisation. " + e.message,
                "error"
              );
            });
        }
      }
    );
  };

  showDuplicate = () => {
    this.setState({ showDuplicate: true });
  };

  duplicate = () => {
    const { snackbar } = this.props;
    const { sourceMerchant, merchantCode } = this.state;

    if (sourceMerchant === "") {
      snackbar("Veuillez saisir un code marchand", "error");
    } else {
      duplicateCatalog(merchantCode, sourceMerchant)
        .then((response) => {
          if (response.result) {
            this.setState({
              sourceMerchant: "",
              showDuplicate: false,
            });
            snackbar("Le catalogue a bien été dupliqué");
          } else
            snackbar("Erreur pendant la duplication du catalogue. ", "error");
        })
        .catch((e) => {
          console.log(e);
          snackbar(
            "Erreur pendant la duplication du catalogue. " + e.message,
            "error"
          );
        });
    }
  };

  uploadFile = async (file, technicalLabel) => {
    const { snackbar } = this.props;
    const {
      merchantCode,
      informations: { id },
    } = this.state;
    if (!allowedExtensions.exec(file.name)) {
      snackbar(
        `Veuillez choisir un fichier valide (.jpg, .jpeg, .png)`,
        "error"
      );
    } else {
      try {
        const informations = await uploadInformationsFile(
          id,
          merchantCode,
          file,
          technicalLabel
        );
        this.setState(
          (state) => ({ informations, randomSuffix: Math.random() }),
          () => snackbar("Fichier enregistré")
        );
      } catch (e) {
        snackbar(
          "Une erreur est survenue pendant l'enregistrement de la photo, veuillez réessayer",
          "error"
        );
      }
    }
  };

  cleanFile = (technicalLabel) => async () => {
    const { snackbar } = this.props;
    const {
      merchantCode,
      informations: { id },
    } = this.state;
    try {
      const informations = await deleteInformationsFile(
        id,
        merchantCode,
        technicalLabel
      );
      var fileinput = document.getElementById(
        "sp-informations--upload-file-" + technicalLabel
      );
      fileinput.value = "";

      this.setState({ informations }, () => snackbar("Fichier supprimé"));
    } catch (e) {
      snackbar(
        "Une erreur est survenue pendant la suppression, veuillez réessayer",
        "error"
      );
    }
  };

  changeLang = (value) => {
    this.setState({ lang: value });
  };

  changeFields = (name) => (eventOrValue) => {
    const { lang } = this.state;
    const value = eventOrValue.target
      ? eventOrValue.target.value
      : eventOrValue;
    this.setState((state) => ({
      informations: {
        ...state.informations,
        value: {
          ...state.informations.value,
          i18n: {
            ...state.informations.value.i18n,
            [lang]: { [name]: value },
          },
        },
      },
    }));
  };

  changeGeocoding = (e) => {
    this.setState({ geocoding: e.target.value });
  };

  findGeolcocalisation = async () => {
    const apiResults = await geocoding(this.state.geocoding);
    if (apiResults && apiResults.results && apiResults.results.length > 0)
      this.setState(
        { geocoding: "" },
        this.changeGeolocalisation(
          apiResults.results[0].geometry.lat,
          apiResults.results[0].geometry.lng,
          16
        )
      );
  };

  changeGeolocalisationFromClick = ({ latLng }) =>
    this.changeGeolocalisation(latLng[0], latLng[1]);

  changeGeolocalisation = (lat, lng, zoom) => {
    this.setState((state) => ({
      zoom,
      informations: {
        ...state.informations,
        geolocalisation: {
          ...state.informations.geolocalisation,
          lat,
          lng,
        },
      },
    }));
  };

  changeDisplayMap = (e) => {
    const { checked } = e.target;
    this.setState((state) => ({
      informations: {
        ...state.informations,
        geolocalisation: {
          ...state.informations.geolocalisation,
          displayMap: checked,
        },
      },
    }));
  };

  changeHour = (day, schedule) => (date) => {
    this.setState((state) => ({
      informations: {
        ...state.informations,
        timetable: state.informations.timetable
          ? {
              ...state.informations.timetable,
              [day]: {
                ...state.informations.timetable[day],
                [schedule]:
                  date !== undefined && date !== null
                    ? format(date, "HH'h'mm")
                    : undefined,
              },
            }
          : {
              [day]: {
                [schedule]:
                  date !== undefined && date !== null
                    ? format(date, "HH'h'mm")
                    : undefined,
              },
            },
      },
    }));
  };

  changeSourceMerchant = (e) => {
    this.setState({ sourceMerchant: e.target.value });
  };

  renderLoader() {
    return <Loader loading={true} />;
  }

  renderFileLine(file, technicalLabel, label, format, width, height) {
    const { merchantCode, randomSuffix } = this.state;
    //const { server } = this.props;
    return (
      <Grid key={technicalLabel} container spacing={16}>
        <Grid item xs={6} sm={6}>
          <Typography
            align="center"
            variant="body1"
            className="sp-informations--filelabel"
          >
            {label}
          </Typography>
          <Typography
            align="center"
            variant="body2"
            className="sp-informations--filelabel"
          >
            {format}
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6}>
          <FormControl margin="normal" fullWidth>
            <input
              className="sp-informations--upload-file"
              id={"sp-informations--upload-file-" + technicalLabel}
              type="file"
              accept="image/*"
              onChange={(e) => {
                if (e.target.files[0]) {
                  this.uploadFile(e.target.files[0], technicalLabel);
                }
              }}
            />
            <label
              className="sp-informations--uploadiconlabel"
              htmlFor={"sp-informations--upload-file-" + technicalLabel}
            >
              <Button variant="contained" component="div">
                {file === undefined || file === "" ? `Ajouter` : `Modifier`}
              </Button>
              {file !== undefined && file !== "" && (
                <Button
                  variant="fab"
                  className="sp-informations--deletefile"
                  onClick={this.cleanFile(technicalLabel)}
                >
                  <DeleteIcon style={{ fontSize: 18 }} />
                </Button>
              )}
            </label>
            <FormHelperText />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12}>
          {file !== undefined && file !== "" ? (
            <img
              alt={label}
              className="sp-informations-filepreview"
              src={withConfiguration(
                (config) =>
                  `${config["imgServer"]}public/${merchantCode}/informations/${file}?${randomSuffix}`
              )}
              width={width}
              height={height}
            />
          ) : (
            <div
              style={{ width: `${width}px`, height: `${height}px` }}
              className="sp-informations--upload-group sp-informations--upload-group_int"
            >
              <AddAPhoto className="sp-informations--uploadicon" />
            </div>
          )}
        </Grid>
      </Grid>
    );
  }

  renderTab(lang) {
    const disabled = this.state.informations.id === undefined;

    const tabClasses = classnames({
      "sp-i18n--tab__disabled": false,
    });
    return (
      <Tab
        key={lang.code}
        className={tabClasses}
        value={lang.code}
        label={lang.label}
        disabled={disabled}
      />
    );
  }

  renderDuplicate() {
    const { isAdmin } = this.state;

    if (isAdmin)
      return (
        <Fragment>
          <CardContent>
            <TextField
              label="Code marchand du catalogue source"
              value={this.state.sourceMerchant}
              onChange={this.changeSourceMerchant}
              margin="normal"
              fullWidth
              variant={"standard"}
            />
          </CardContent>
          <CardActions className="sp-informations--actions">
            <Button
              variant="contained"
              color="secondary"
              onClick={this.duplicate}
            >
              Dupliquer
            </Button>
          </CardActions>
        </Fragment>
      );
  }

  render() {
    const {
      lang,
      informations,
      merchantCategories,
      errors,
      zoom,
      geocoding,
      merchantKind,
    } = this.state;
    const { langs } = this.props;
    const { isAdmin, showDuplicate } = this.state;
    const disabled = informations && informations.id !== undefined;
    const isStandardProducts = merchantKind === "STAND";
    return informations !== undefined ? (
      <Card key="page">
        <CardContent>
          <Grid
            container
            spacing={16}
            style={showDuplicate ? { display: "none" } : {}}
          >
            {!disabled && (
              <Grid item xs={12} sm={12}>
                <Typography
                  align="center"
                  variant="body1"
                  className="sp-informations--filelabel"
                >
                  Attention : Une fois enregistrées, vous ne pourrez plus
                  modifier ces informations
                </Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Nom"
                value={informations.name}
                margin="normal"
                inputProps={{ readOnly: true }}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Slug"
                value={informations.slug}
                onChange={this.changeInfo("slug")}
                margin="normal"
                inputProps={{ readOnly: disabled }}
                fullWidth
                variant={disabled ? "outlined" : "standard"}
                error={errors && errors.slug !== undefined}
                helperText={
                  errors && errors.slug && constructError(errors.slug)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                label="Catégorie de marchand"
                value={informations.merchantCategoryId}
                onChange={this.changeInfo("merchantCategoryId")}
                margin="normal"
                inputProps={{ readOnly: disabled }}
                fullWidth
                variant={disabled ? "outlined" : "standard"}
                error={errors && errors.merchantCategoryId !== undefined}
                helperText={
                  errors &&
                  errors.merchantCategoryId &&
                  constructError(errors.merchantCategoryId)
                }
              >
                {disabled ? (
                  <MenuItem
                    key={informations.merchantCategoryId}
                    value={informations.merchantCategoryId}
                  >
                    {informations.merchantCategory &&
                      informations.merchantCategory.label}
                  </MenuItem>
                ) : (
                  <MenuItem key="" value="" />
                )}
                {merchantCategories.map((category) => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                label="Réseau"
                value={
                  isStandardProducts
                    ? networks[0]
                    : informations.value && informations.value.network
                }
                onChange={this.changeJsonInfo("network")}
                margin="normal"
                fullWidth
                error={
                  errors &&
                  errors.value !== undefined &&
                  errors.value.network !== undefined
                }
                helperText={
                  errors &&
                  errors.value &&
                  errors.value.network &&
                  constructError(errors.value.network)
                }
                disabled={isStandardProducts}
              >
                {isStandardProducts ? "" : <MenuItem key="" value="" />}
                {networks.map((network) => (
                  <MenuItem key={network} value={network}>
                    {network}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Nombre de jours minimum avant prestation"
                type="number"
                inputProps={{ min: "1" }}
                value={informations.value && informations.value["j-"]}
                margin="normal"
                fullWidth
                onChange={this.changeJsonInfo("j-", "number")}
                error={
                  errors && errors.value && errors.value["j-"] !== undefined
                }
                helperText={
                  errors &&
                  errors.value &&
                  errors.value["j-"] !== undefined &&
                  constructError(errors.value["j-"])
                }
              />
            </Grid>
          </Grid>
          <Divider className="sp-informations--divider" light />
          <Grid style={showDuplicate ? { display: "none" } : {}}>
            <I18n
              hideLabel={true}
              langs={langs}
              lang={lang}
              changeFields={this.changeFields}
              changeLang={this.changeLang}
              elements={informations.value && informations.value.i18n}
              emptyElement={{ description: "" }}
              errors={errors && errors.value && errors.value.i18n}
            />
            <Divider className="sp-informations--divider" light />
            <Grid container>
              <Grid item xs={8} sm={9}>
                <TextField
                  label="Rechercher une adresse..."
                  value={geocoding}
                  onChange={this.changeGeocoding}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={4} sm={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={this.findGeolcocalisation}
                  fullWidth
                  style={{ marginTop: "20px" }}
                >
                  Rechercher
                </Button>
              </Grid>
            </Grid>
            <Map
              center={
                informations.geolocalisation
                  ? [
                      informations.geolocalisation.lat,
                      informations.geolocalisation.lng,
                    ]
                  : [46.532, 2.766]
              }
              defaultZoom={informations.geolocalisation ? 15 : 5}
              zoom={zoom}
              height={400}
              provider={(x, y, z) => {
                const s = String.fromCharCode(97 + ((x + y + z) % 3));
                return `https://${s}.tile.openstreetmap.org/${z}/${x}/${y}.png`;
              }}
              onClick={this.changeGeolocalisationFromClick}
            >
              {informations.geolocalisation && (
                <Marker
                  anchor={[
                    informations.geolocalisation.lat,
                    informations.geolocalisation.lng,
                  ]}
                  payload={1}
                  onClick={({ event, anchor, payload }) => {}}
                />
              )}
            </Map>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      informations.geolocalisation
                        ? informations.geolocalisation.displayMap
                        : false
                    }
                    onChange={this.changeDisplayMap}
                    value="displayMap"
                    color="secondary"
                  />
                }
                label={"Afficher la carte sur la page marchand"}
              />
            </Grid>
            <Divider className="sp-informations--divider" light />
            <InformationsTimetable
              timetable={informations && informations.timetable}
              changeHour={this.changeHour}
            />
          </Grid>
          {!showDuplicate &&
            disabled && [
              <Divider
                key="divider1"
                className="sp-informations--divider"
                light
              />,
              this.renderFileLine(
                informations.value && informations.value.banner,
                "banner",
                "Bandeau",
                "1400 × 700px",
                462,
                231
              ),
              this.renderFileLine(
                informations.value && informations.value.thumb,
                "thumb",
                "Vignette",
                "360 × 240px",
                240,
                160
              ),
            ]}
        </CardContent>
        {showDuplicate && this.renderDuplicate()}
        <CardActions className="sp-informations--actions">
          {isAdmin && disabled && !showDuplicate && (
            <Button
              variant="contained"
              color="primary"
              onClick={this.showDuplicate}
            >
              Dupliquer depuis un catalogue
            </Button>
          )}
          {!showDuplicate && (
            <Button
              variant="contained"
              color="secondary"
              onClick={this.saveInformations}
            >
              Valider
            </Button>
          )}
        </CardActions>
      </Card>
    ) : (
      this.renderLoader()
    );
  }
}

const enhanced = (WrappedComponent) => (props) => {
  return (
    <AppContext.Consumer>
      {(app) => (
        <WrappedComponent
          {...props}
          snackbar={app.snackbar.open}
          langs={app.langs}
          server={app.server}
          setInit={app.setInit}
        />
      )}
    </AppContext.Consumer>
  );
};

export default withRouter(enhanced(Informations));



// WEBPACK FOOTER //
// ./src/components/informations/Informations.js